import { render, staticRenderFns } from "./RegistrationRedirect.vue?vue&type=template&id=57559148&scoped=true"
import script from "./RegistrationRedirect.vue?vue&type=script&lang=js"
export * from "./RegistrationRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57559148",
  null
  
)

export default component.exports